import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

export const PlayerSlate = ({ text }) => {
  return <PlayerSlateEl>{text}</PlayerSlateEl>;
};

const PlayerSlateEl = styled.div`
  align-items: center;
  aspect-ratio: 16 / 9;
  ${(props) =>
    props.theme.name === 'light'
      ? `color: ${props.theme.color.black}`
      : `color: ${props.theme.color.white}`};
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
  border-radius: 8px;
  display: flex;
  font-weight: bold;
  font-size: 18px;
  justify-content: center;
  width: 100%;
`;

PlayerSlate.propTypes = {
  text: PropTypes.string,
};

PlayerSlate.defaultProps = {
  text: 'Stream not avilable',
};
